import { render, staticRenderFns } from "./account-info.vue?vue&type=template&id=63f45e57&scoped=true&"
import script from "./account-info.vue?vue&type=script&lang=js&"
export * from "./account-info.vue?vue&type=script&lang=js&"
import style0 from "./account-info.vue?vue&type=style&index=0&id=63f45e57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f45e57",
  null
  
)

export default component.exports